<template>
  <div class="font-hiraginoSans-w3">
    <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
      <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
        <p>予約日時</p>
      </div>
      <div class="customer-info-mobile">
        <span class="bookingDate">{{ formattedBookingDate }}</span>
      </div>
    </div>
    <div class="row row-plan-border-mobile py-1 mb-0 p-3 timeprice-confirm">
      <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
        <p>メニュー</p>
      </div>
      <div class="customer-info-mobile">
        <span class="timepriceName">{{ formattedTimeprice }}</span>
      </div>
    </div>
    <div v-if="selectedTimepriceOptions.length > 0" class="row row-plan-border-mobile py-1 mb-0 p-3 timeprice-option-confirm border-top-0-mobile">
      <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
        <p>オプションメニュー：</p>
      </div>
      <div class="customer-info-mobile">
        <span class="timepriceOptionName">{{ formattedTimepriceOptions }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'BookingInfo',
  computed: {
    ...mapGetters('permalink', ['selectedEvent', 'customerData', 'selectedTimeprice', 'selectedTherapist', 'selectedTimepriceOptions']),
    formattedBookingDate() {
      const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
      const start = new Date(this.selectedEvent.startStr);
      const totalMinutes = this.selectedTimeprice.timeunit + this.selectedTimepriceOptions.reduce((sum, option) => sum + option.timeunit, 0);
      const end = new Date(start.getTime() + totalMinutes * 60000);
      const year = start.getFullYear();
      const month = start.getMonth() + 1;
      const date = start.getDate();
      const day = daysOfWeek[start.getDay()];
      const startTime = start.toTimeString().slice(0, 5);
      const endTime = end.toTimeString().slice(0, 5);
      return `${year}年${month}月${date}日 (${day}) ${startTime} ~ ${endTime}`;
    },
    formattedTimeprice() {
      const { name, unitprice, timeunit } = this.selectedTimeprice;
      let result = name;

      if (unitprice) {
        result += `/${unitprice}円`;
      }

      if (timeunit) {
        result += `/${timeunit}分`;
      }

      return result;
    },
    formattedTimepriceOptions() {
      return this.selectedTimepriceOptions.map(option => {
        const { name, unitprice, timeunit } = option;
        let result = name;

        if (unitprice) {
          result += `/${unitprice}円`;
        }

        if (timeunit) {
          result += `/${timeunit}分`;
        }

        return result;
      }).join(', ');
    }
  }
};
</script>

<style scoped>
</style>
